export default "__VITE_ASSET__DM24OCqA__"